import { api } from '@lib/api';
import { dosyaAdiCoz } from './lisansPasif';

/** GET /veri-disa-aktar → .xlsx dosyasını tarayıcıda indirir. */
export async function verileriIndir(): Promise<void> {
  const yanit = await api.get('veri-disa-aktar', {
    timeout: 120_000,
    retry: 0,
  });
  const blob = await yanit.blob();
  const ad = dosyaAdiCoz(yanit.headers.get('content-disposition'), 'zoprey-crm-verilerim.xlsx');

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = ad;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
